import { render, staticRenderFns } from "./coupons.vue?vue&type=template&id=407e87d4&scoped=true&lang=pug"
import script from "./coupons.vue?vue&type=script&lang=coffee"
export * from "./coupons.vue?vue&type=script&lang=coffee"
import style0 from "./coupons.vue?vue&type=style&index=0&id=407e87d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407e87d4",
  null
  
)

export default component.exports